var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultIconSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.16675V10.0834",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.16675V10.0834",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24549 17.9351C9.63588 20.2203 14.1255 19.4602 16.656 16.1724C19.1865 12.8847 18.9437 8.12727 16.093 5.14093C13.2423 2.1546 8.70086 1.90022 5.5624 4.55109C2.42395 7.20196 1.69826 11.9051 3.87968 15.4568",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87965 15.4568L3.50611 17.799C3.48282 17.945 3.52832 18.0939 3.62827 18.1986C3.72822 18.3033 3.8703 18.351 4.00972 18.3266L6.24535 17.9352",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1125 12.9342C12.3778 13.5636 11.4606 13.9124 10.5116 13.9232C9.56336 13.965 8.62978 13.6675 7.86435 13.0797",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIconSmile);
export default __webpack_public_path__ + "static/media/defaultIconSmile.47b566a5c8c4943b0d6e34a26a664483.svg";
export { ForwardRef as ReactComponent };